import { Option } from '@storeblocks/radio';
import { CancelDateCategory } from 'Forms/CancelFormV2/cancelForm.constants';
import { CancelFormValues } from 'Forms/CancelFormV2/cancelForm.types';
import { ChangeFormValues } from 'Forms/ChangeForm/changeForm.types';
import { DateString } from 'Types/date.types';
import { getPreviousDayDate } from 'Utils/date/date.utils';
import { getAppText } from 'Utils/text';
import { isDefined } from 'Utils/type.utils';
import { CancelReasonAkaStudent } from './cancelAkaStudentForm.constants';
import { CancelAkaStudentFormValues } from './cancelAkaStudentForm.types';

export const shouldHaveFutureCancelDateAkaStudent = (
  cancelReason: unknown,
): boolean =>
  cancelReason === CancelReasonAkaStudent.NOT_LONGER_IN_UNION ||
  cancelReason === CancelReasonAkaStudent.NEW_INSURANCE ||
  cancelReason === CancelReasonAkaStudent.MOVED;

export const mapCancelDateCategory = (
  values: CancelAkaStudentFormValues,
): CancelDateCategory => {
  if (
    isDefined(values.cancelReason) &&
    shouldHaveFutureCancelDateAkaStudent(values.cancelReason)
  ) {
    return CancelDateCategory.FUTURE;
  }
  return CancelDateCategory.RENEWAL;
};

export const isCancelAkaStudentFormValues = (
  values: CancelFormValues | ChangeFormValues,
): values is CancelAkaStudentFormValues => {
  return (
    'futureCancelDate' in values &&
    (values.futureCancelDate === undefined ||
      values.futureCancelDate instanceof Date)
  );
};

export const getSubmitSuccessDescriptionAkaStudent = (
  values: CancelFormValues | ChangeFormValues,
  renewalDate: string,
): string => {
  if (isCancelAkaStudentFormValues(values)) {
    if (
      isDefined(values.cancelReason) &&
      shouldHaveFutureCancelDateAkaStudent(values.cancelReason) &&
      isDefined(values.futureCancelDate)
    ) {
      const dayBefore = getPreviousDayDate(
        values.futureCancelDate.toLocaleDateString() as DateString,
      );

      return getAppText('cancel.travel.alert.submitSuccesOnDate.description', {
        insert: {
          dayBeforeCancelDate: dayBefore,
        },
      });
    }

    if (
      isDefined(values.cancelReason) &&
      values.cancelReason === CancelReasonAkaStudent.NOT_IN_NEED
    ) {
      const dayBefore = getPreviousDayDate(renewalDate as DateString);
      return getAppText(
        'cancel.travel.alert.submitSuccesOnRenewal.description',
        { insert: { dayBeforeRenewal: dayBefore } },
      );
    }
  }

  return '';
};

export const showFutureCancelDate = (
  values: CancelAkaStudentFormValues,
): boolean =>
  isDefined(values.cancelReason) &&
  shouldHaveFutureCancelDateAkaStudent(values.cancelReason);

export const getAkaStudentCancellationOptions = (): Option[] => [
  {
    label: getAppText('cancel.akaStudent.cancelReason.option.notInUnion'),
    value: CancelReasonAkaStudent.NOT_LONGER_IN_UNION,
    id: 'cancelReason-1',
  },
  {
    label: getAppText('cancel.akaStudent.cancelReason.option.newInsurance'),
    value: CancelReasonAkaStudent.NEW_INSURANCE,
    id: 'cancelReason-2',
  },
  {
    label: getAppText('cancel.akaStudent.cancelReason.option.moved'),
    value: CancelReasonAkaStudent.MOVED,
    id: 'cancelReason-3',
  },
  {
    label: getAppText('cancel.akaStudent.cancelReason.option.notInNeed'),
    value: CancelReasonAkaStudent.NOT_IN_NEED,
    id: 'cancelReason-4',
  },
];
